import script from "./ClientBlockPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientBlockPage.vue?vue&type=script&setup=true&lang=ts"

import "./ClientBlockPage.vue?vue&type=style&index=0&id=7012f51e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7012f51e"]])

export default __exports__